<template>
  <div>
    <div class="center-between mb-4">
      <h1 class="m-0" v-text="$t('storeLayout.label', 2)" />
      <button
        class="small"
        @click="$store.dispatch('modals/openModal', { modal: 'editStoreLayout', entity: {
          name: '',
          tables: [],
          store: `/stores/${$route.params.storeId}`,
        } })"
      >
        +
      </button>
    </div>

    <entity-table
      v-model:sortBy="sortBy"
      v-model:sortDirection="sortDirection"
      :fields="fields"
      :entities="entities"
      :loading="loadingEntities"
      :current-page="currentPage"
      :total-items="totalItems"
      @click:edit="$store.dispatch('modals/openModal', { modal: 'editStoreLayout', entity: normalizeEntity($event) })"
      @click:delete="$store.dispatch('modals/openModal', { modal: 'deleteStoreLayout', entity: $event })"
      @update:sort="loadEntities()"
      @update:page="currentPage = $event; loadEntities()"
    >
      <template #cell(tables)="data">
        {{ data.value.length }}
      </template>
    </entity-table>

    <edit-store-layout-modal @update="loadEntities" />
    <delete-modal type="deleteStoreLayout" entity-translation-key="storeLayout" label="name" @update="loadEntities" />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import useEntityFields from '@/hooks/api/fields';
import useLoadEntities from '@/hooks/api/loadEntities';
import EntityTable from '@/components/shared/EntityTable/EntityTable.vue';
import DeleteModal from '@/components/shared/DeleteModal.vue';
import EditStoreLayoutModal from '@/components/entities/store_layout/EditStoreLayoutModal.vue';

export default {
  name: 'ScaleIndexPage',
  components: {
    EditStoreLayoutModal,
    DeleteModal,
    EntityTable,
  },
  setup() {
    const route = useRoute();
    const { storeLayout: fields } = useEntityFields();
    const {
      entities,
      loadingEntities,
      currentPage,
      totalItems,
      sortBy,
      sortDirection,
      loadEntities,
    } = useLoadEntities('/store_layouts', {
      sort: 'name',
      defaultParams: {
        store: route.params.storeId,
      },
    });

    const normalizeEntity = (entity) => ({
      ...entity,
      store: entity?.store?.['@id'],
    });

    return {
      fields,
      entities,
      loadingEntities,
      currentPage,
      totalItems,
      sortBy,
      sortDirection,
      loadEntities,
      normalizeEntity,
    };
  },
};
</script>
